<div class="col-lg-12 content-scroll-screen parent">
  <div class="row child">
    <p-card class="card-spacing-0">
      <span
        class="d-flex justify-content-between align-items-center p-3 globalborder-btm-header">
        <span class="col-auto">
          <h2 class="mb-0">Add New Vendor</h2>
        </span>
      </span>
      <div class="col-lg-12 adduser-container-hgt">
        <form [formGroup]="vendorForm">
          <div class="m-3">
            <div class="row">
              <div class="col-3">
                <div class="gray-bg-rounded">
                  <h3>Vendor Information</h3>
                  <div class="vendors-info" formGroupName="basicInformation">
                    <div class="row">
                      <div class="form-group has-float-label mb-2">
                        <label class="form-label" for="vendorAccount"
                          >Vendor Account</label
                        >
                        <input
                          jniAutoCompleteBlocker
                          type="text"
                          id="vendorAccount"
                          pInputText
                          name="vendorAccount"
                          [(ngModel)]="customerAccount"
                          [ngClass]="{
                            'textboxcolor-gray': customerAccountNumberStatus,
                          }"
                          formControlName="vendorAccountNumberD365" />
                      </div>

                      <div class="form-group has-float-label mb-2">
                        <label class="form-label" for="vendorDefaultSelectionId"
                          >Type</label
                        >
                        <p-select
                          [(ngModel)]="vendorDefaultSelectionId"
                          formControlName="vendorPartyTypeD365"
                          (onChange)="
                            onVendorSelectionChange(vendorDefaultSelectionId)
                          "
                          [options]="typeList"
                          optionValue="typeDescription"
                          optionLabel="typeDescription">
                        </p-select>
                      </div>

                      <div class="form-group has-float-label flex-grow-1 mb-2">
                        <label class="form-label" for="taxId"
                          >Tax ID<span class="madatory-field">*</span></label
                        >
                        <input
                          #TaxIdInput
                          jniAutoCompleteBlocker
                          type="text"
                          pInputText
                          id="taxId"
                          name="taxId"
                          placeholder=""
                          formControlName="tax1099FederalTaxIdD365"
                          [ngClass]="{
                            'has-error': formErrors['tax1099FederalTaxIdD365'],
                          }"
                          (blur)="logValidationErrors()"
                          (input)="searchTaxId$.next($any($event.target).value)"
                          (keyup)="onTaxIdFilter($event, TaxIdInput)" />

                        <span
                          class="error-msg"
                          *ngIf="formErrors['tax1099FederalTaxIdD365']">
                          {{ formErrors["tax1099FederalTaxIdD365"] }}
                        </span>
                      </div>
                      <!-- <a class="ms-1 mb-1 mt-1 text-decoration-none"
                        >Need To Make without Content</a
                      > -->
                      <p-popover #taxIdPopover>
                        <div class="row">
                          <div class="col-8">
                            <p-table
                              #dt
                              stripedRows
                              [value]="vendorVerification"
                              [rowHover]="true"
                              [rows]="10"
                              [size]="'small'"
                              scrollHeight="300px"
                              [showCurrentPageReport]="true"
                              [rowsPerPageOptions]="[10, 25, 50]"
                              [paginator]="false"
                              [filterDelay]="0"
                              selectionMode="multiple"
                              styleClass="table-listing popuptable">
                              <ng-template pTemplate="header">
                                <tr class="table-head">
                                  <th class="name">Name</th>
                                  <th class="vaccount">Vendor Account</th>
                                  <th class="sname">Search name</th>
                                  <th class="type">Type</th>
                                </tr>
                              </ng-template>
                              <ng-template
                                pTemplate="body"
                                let-vendorVerification
                                let-rowIndex="rowIndex">
                                <tr
                                  class="p-selectable-row mouse-pointer"
                                  (click)="
                                    getVendorDetails(
                                      vendorVerification.vendorAccountNumber
                                    )
                                  ">
                                  <td class="name mouse-pointer">
                                    {{ vendorVerification.vendorName }}
                                  </td>
                                  <td class="vaccount mouse-pointer">
                                    {{ vendorVerification.vendorAccountNumber }}
                                  </td>
                                  <td class="sname mouse-pointer">
                                    {{ vendorVerification.vendorSearchName }}
                                  </td>
                                  <td class="type mouse-pointer">
                                    {{ vendorVerification.vendorType }}
                                  </td>
                                </tr>
                              </ng-template>
                              <ng-template pTemplate="emptymessage">
                                <tr>
                                  <td colspan="20">No vendor found.</td>
                                </tr>
                              </ng-template>
                            </p-table>
                          </div>
                          <div class="col-4">
                            <h3 ngbNavLink class="mt-4 mb-4">General</h3>
                            <ul class="listing-table-pophover">
                              <li>
                                <ng-template ngbNavContent>
                                  <div class="mb-3">
                                    <div class="title">Phone number</div>
                                    <div class="description">
                                      {{ generalvendorObject?.phoneNumber }}
                                    </div>
                                  </div>
                                  <div class="mb-3">
                                    <div class="title">Email Address</div>
                                    <div class="description">
                                      {{ generalvendorObject?.emailAddress }}
                                    </div>
                                  </div>
                                  <div class="mb-3">
                                    <div class="title">Primary Address</div>
                                    <div class="description">
                                      {{ generalvendorObject?.primaryAddress }}
                                    </div>
                                  </div>
                                </ng-template>
                              </li>
                            </ul>
                            <div class="mt-2"></div>
                          </div>
                        </div>
                      </p-popover>
                    </div>
                    <div class="row">
                      <div
                        class="form-group has-float-label mb-2"
                        *ngIf="legalNameStatus">
                        <label
                          class="form-label"
                          for="vendorOrganizationNameD365"
                          >Legal Name<span class="madatory-field"
                            >*</span
                          ></label
                        >
                        <input
                          #legalNameInput
                          jniAutoCompleteBlocker
                          type="text"
                          pInputText
                          class="p-column-filter form-control"
                          placeholder=""
                          id="vendorOrganizationNameD365"
                          name="vendorOrganizationNameD365"
                          formControlName="vendorOrganizationNameD365"
                          [ngClass]="{
                            'has-error':
                              formErrors['vendorOrganizationNameD365'],
                          }"
                          (blur)="logValidationErrors()"
                          (input)="
                            searchVendor$.next($any($event.target).value)
                          "
                          (keyup)="onLegalNameFilter($event, legalNameInput)" />
                        <span
                          class="error-msg"
                          *ngIf="formErrors['vendorOrganizationNameD365']">
                          {{ formErrors["vendorOrganizationNameD365"] }}
                        </span>
                      </div>

                      <div *ngIf="legalNameStatus">
                        <div class="form-group has-float-label mb-2">
                          <label class="form-label" for="knownAs"
                            >Known As</label
                          >
                          <input
                            jniAutoCompleteBlocker
                            type="text"
                            pInputText
                            id="knownAs"
                            name="knownAs"
                            formControlName="vendorKnownAsNameD365"
                            placeholder=""
                            [ngClass]="{
                              'has-error': formErrors['vendorKnownAsNameD365'],
                            }"
                            (blur)="logValidationErrors()" />

                          <span
                            class="error-msg"
                            *ngIf="formErrors['vendorKnownAsNameD365']">
                            {{ formErrors["vendorKnownAsNameD365"] }}
                          </span>
                        </div>
                      </div>
                      <div class="col mb-4"></div>
                    </div>
                    <div class="row" *ngIf="typePersonStatus">
                      <div class="col mb-4 height-drop-menu">
                        <div
                          class="form-group has-float-label"
                          id="dropdownBasic2">
                          <input
                            jniAutoCompleteBlocker
                            pInputText
                            type="text"
                            id="firstname"
                            name="firstname"
                            formControlName="firstNameD365"
                            placeholder=""
                            (keyup)="onFirstNameFilter($event)"
                            (keypress)="onFirstNameValidation($event)"
                            [ngClass]="{
                              'has-error': formErrors['firstNameD365'],
                            }"
                            (blur)="logValidationErrors()" />
                          <label class="form-label" for="firstname"
                            >First Name</label
                          >
                          <span
                            class="error-msg"
                            *ngIf="formErrors['firstNameD365']">
                            {{ formErrors["firstNameD365"] }}
                          </span>
                        </div>
                        <p-popover #firstNamePopover class="first-name">
                          <div class="row">
                            <div class="col-8">
                              <p-table
                                #dt
                                stripedRows
                                [showCurrentPageReport]="true"
                                [scrollable]="true"
                                scrollHeight="300px"
                                [size]="'small'"
                                [value]="vendorVerification"
                                [rowHover]="true"
                                [rows]="10"
                                [showCurrentPageReport]="true"
                                [rowsPerPageOptions]="[10, 25, 50]"
                                [paginator]="false"
                                [filterDelay]="0"
                                selectionMode="multiple"
                                styleClass="table-listing popuptable">
                                <ng-template pTemplate="header">
                                  <tr class="table-head">
                                    <th class="name">Name</th>
                                    <th class="vaccount">Vendor Account</th>
                                    <th class="sname">Search name</th>
                                    <th class="type">Type</th>
                                  </tr>
                                </ng-template>
                                <ng-template
                                  pTemplate="body"
                                  let-vendorVerification
                                  let-rowIndex="rowIndex">
                                  <tr
                                    class="p-selectable-row mouse-pointer"
                                    (click)="
                                      getVendorDetails(
                                        vendorVerification.vendorAccountNumber
                                      )
                                    ">
                                    <td class="name mouse-pointer">
                                      {{ vendorVerification.vendorName }}
                                    </td>
                                    <td class="vaccount mouse-pointer">
                                      {{
                                        vendorVerification.vendorAccountNumber
                                      }}
                                    </td>
                                    <td class="sname mouse-pointer">
                                      {{ vendorVerification.vendorSearchName }}
                                    </td>
                                    <td class="type mouse-pointer">
                                      {{ vendorVerification.vendorType }}
                                    </td>
                                  </tr>
                                </ng-template>
                                <ng-template pTemplate="emptymessage">
                                  <tr>
                                    <td colspan="20">No vendor found.</td>
                                  </tr>
                                </ng-template>
                              </p-table>
                            </div>
                            <div class="col-4">
                              <h2 ngbNavLink>General</h2>
                              <ul>
                                <li>
                                  <ng-template ngbNavContent>
                                    <div class="mb-3">
                                      <div class="title">Phone number</div>
                                      <div class="description">
                                        {{ generalvendorObject?.phoneNumber }}
                                      </div>
                                    </div>
                                    <div class="mb-3">
                                      <div class="title">Email Address</div>
                                      <div class="description">
                                        {{ generalvendorObject?.emailAddress }}
                                      </div>
                                    </div>
                                    <div class="mb-3">
                                      <div class="title">Primary Address</div>
                                      <div class="description">
                                        {{
                                          generalvendorObject?.primaryAddress
                                        }}
                                      </div>
                                    </div>
                                  </ng-template>
                                </li>
                              </ul>
                              <div class="mt-2"></div>
                            </div>
                          </div>
                        </p-popover>
                      </div>
                      <div class="col mb-4">
                        <div class="form-group has-float-label">
                          <input
                            pInputText
                            jniAutoCompleteBlocker
                            type="text"
                            id="middlename"
                            name="middlename"
                            formControlName="middleNameD365"
                            placeholder=""
                            (keypress)="onMiddleNameValidation($event)"
                            [ngClass]="{
                              'has-error': formErrors['middleNameD365'],
                            }"
                            (blur)="logValidationErrors()" />
                          <label class="form-label" for="middlename"
                            >Middle Name</label
                          >
                          <span
                            class="error-msg"
                            *ngIf="formErrors['middleNameD365']">
                            {{ formErrors["middleNameD365"] }}
                          </span>
                        </div>
                      </div>
                      <div class="col mb-4">
                        <div class="form-group has-float-label">
                          <input
                            pInputText
                            jniAutoCompleteBlocker
                            type="text"
                            id="lastname"
                            name="lastname"
                            formControlName="lastNameD365"
                            placeholder=""
                            (keypress)="onLastNameValidation($event)"
                            [ngClass]="{
                              'has-error': formErrors['lastNameD365'],
                            }"
                            (blur)="logValidationErrors()" />
                          <label class="form-label" for="lastname"
                            >Last Name</label
                          >
                          <span
                            class="error-msg"
                            *ngIf="formErrors['lastNameD365']">
                            {{ formErrors["lastNameD365"] }}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <div>
                          <div class="d-flex justify-content-between">
                            <h3>W9.PDF</h3>
                            <a
                              href="https://www.irs.gov/pub/irs-pdf/fw9.pdf"
                              target="_blank"
                              class="d-block"
                              >Download</a
                            >
                          </div>
                        </div>
                      </div>
                      <div class="col-12 mb-4 d-flex filelabel">
                        <!-- <p-fileupload
                          #fu
                          jniAutoCompleteBlocker
                          type="file"
                          id="file"
                          (change)="getVendorW9Upload($event)"
                          accept="application/pdf" /> -->

                        <p-fileupload
                          #fu
                          name="w9File"
                          accept="application/pdf"
                          maxFileSize="10000000"
                          [customUpload]="true"
                          (uploadHandler)="handleW9Upload($event)"
                          [showUploadButton]="false"
                          [showCancelButton]="false"
                          [auto]="true"
                          chooseIcon="pi pi-file-pdf"
                          chooseLabel="Choose PDF File"
                          class="jni-fileupload-hidden">
                          <ng-template
                            pTemplate="content"
                            let-files
                            let-chooseCallback="chooseCallback">
                            <div
                              class="po-attachment-drag-drop-container"
                              (dragover)="onDragOver($event)"
                              (drop)="onFileDrop($event)"
                              (dragleave)="onDragLeave($event)"
                              (dragenter)="onDragEnter($event)">
                              <div
                                class="po-attachment-drag-drop-area"
                                [class.drag-over]="isDragOver">
                                <i
                                  class="pi pi-cloud-upload po-attachment-drag-drop-icon"></i>
                                <div class="po-attachment-drag-drop-text">
                                  <p class="mb-2">Drag & Drop W9 PDF here</p>
                                </div>
                              </div>
                              <!-- File preview is handled by your custom logic outside this template -->
                            </div>
                          </ng-template>
                        </p-fileupload>

                        <!-- <label class="vendors-fileupload">
                          <input
                            jniAutoCompleteBlocker
                            type="file"
                            id="file"
                            (change)="getVendorW9Upload($event)"
                            accept="application/pdf" />
                          Upload new File
                        </label> -->
                        <span
                          class="text-primary small filelabel"
                          data-toggle="tooltip"
                          [title]="w9FileName">
                          {{ w9FileName }}
                        </span>
                        <div class="error fileupload" *ngIf="w9FileSize">
                          File must be less than 1 MB
                        </div>
                        <div class="error fileupload" *ngIf="w9FileTypeStatus">
                          File type must be pdf format
                        </div>
                      </div>
                      <div class="col-12 mb-2">
                        <div class="form-group has-float-label">
                          <label class="form-label" for="vendorGroupIdD365"
                            >Group<span class="madatory-field">*</span></label
                          >
                          <p-select
                            formControlName="vendorGroupIdD365"
                            [ngClass]="{
                              'has-error': formErrors['vendorGroupIdD365'],
                            }"
                            (blur)="logValidationErrors()"
                            [(ngModel)]="vendorGroupId"
                            [options]="vendorGroupList"
                            optionValue="vendorGroupIdD365"
                            optionLabel="vendorGroupIdD365">
                          </p-select>

                          <span
                            class="error-msg"
                            *ngIf="formErrors['vendorGroupIdD365']">
                            {{ formErrors["vendorGroupIdD365"] }}
                          </span>
                        </div>
                      </div>
                      <div class="col-12 mb-2">
                        <div class="form-group has-float-label">
                          <label class="form-label" for="salesCurrencyCodeD365"
                            >Currency</label
                          >
                          <p-select
                            id="currency"
                            formControlName="salesCurrencyCodeD365"
                            [(ngModel)]="defaultCurrency"
                            [options]="currencyList"
                            optionValue="isoCurrencyCodeD365"
                            optionLabel="isoCurrencyCodeD365">
                          </p-select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-3">
                <div class="gray-bg-rounded">
                  <jni-address
                    [parent]="vendorForm"
                    [formgroupName]="'addressInformation'"
                    [cityList]="cityList"
                    [countryRegionList]="countryRegionList"
                    [countyList]="countyList"
                    [districtList]="districtList"
                    [stateList]="stateList"></jni-address>
                </div>
              </div>

              <div class="vendors-info col-6">
                <div class="gray-bg-rounded">
                  <h3>Vendor Profile</h3>
                  <div class="col-lg-12">
                    <div class="row">
                      <div class="col-4 mb-2">
                        <div
                          class="form-group has-float-label"
                          formGroupName="basicInformation">
                          <label class="form-label" for="ethinicOrigin"
                            >Ethnic Origin</label
                          >
                          <p-select
                            formControlName="ethinicOrigin"
                            [options]="ethinicOrigin">
                          </p-select>
                        </div>
                      </div>
                      <div class="col-4 mb-2 d-flex align-items-end">
                        <div class="d-flex align-items-end gap-1">
                          <p-checkbox
                            name="Eco-Friendly Business"
                            (click)="venderprofileCheckboxButton($event)"
                            id="check1"
                            [binary]="true" />
                          <label class="form-check-label" for="check1">
                            Eco-Friendly Business
                          </label>
                        </div>
                      </div>
                      <div class="col-4 mb-2 d-flex align-items-end">
                        <div class="d-flex align-items-end gap-1">
                          <p-checkbox
                            (click)="venderprofileCheckboxButton($event)"
                            name="Bid-Only"
                            id="check2"
                            [binary]="true" />
                          <label class="form-check-label" for="check2">
                            Bid-Only
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-lg-12">
                    <div class="row">
                      <div class="col-4 mb-2">
                        <div class="d-flex align-items-end gap-1">
                          <p-checkbox
                            (click)="venderprofileCheckboxButton($event)"
                            name="One Time Supplier"
                            id="check3"
                            [binary]="true" />
                          <label class="form-check-label" for="check3">
                            One Time Supplier
                          </label>
                        </div>
                      </div>
                      <div class="col-4 mb-2">
                        <div class="d-flex align-items-end gap-1">
                          <p-checkbox
                            (click)="venderprofileCheckboxButton($event)"
                            name="Owner is a service veteran"
                            id="check4"
                            [binary]="true" />
                          <label class="form-check-label" for="check4">
                            Owner is a service veteran
                          </label>
                        </div>
                      </div>
                      <div class="col-4 mb-2">
                        <div class="d-flex align-items-end gap-1">
                          <p-checkbox
                            (click)="venderprofileCheckboxButton($event)"
                            name="Union Friendly"
                            id="check5"
                            [binary]="true" />
                          <label class="form-check-label" for="check5">
                            Union Friendly
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-12">
                    <div class="row">
                      <div class="col-4 mb-2">
                        <div class="d-flex align-items-end gap-1">
                          <p-checkbox
                            (click)="venderprofileCheckboxButton($event)"
                            name="Promotional"
                            id="check6"
                            [binary]="true" />
                          <label class="form-check-label" for="check6">
                            Promotional
                          </label>
                        </div>
                      </div>
                      <div class="col-4 mb-2">
                        <div class="d-flex align-items-end gap-1">
                          <p-checkbox
                            (click)="venderprofileCheckboxButton($event)"
                            name="Small Business"
                            id="check7"
                            [binary]="true" />
                          <label class="form-check-label" for="check7">
                            Small Business
                          </label>
                        </div>
                      </div>
                      <div class="col-4 mb-2">
                        <div class="d-flex align-items-end gap-1">
                          <p-checkbox
                            (click)="venderprofileCheckboxButton($event)"
                            name="Owner is disable"
                            id="check8"
                            [binary]="true" />
                          <label class="form-check-label" for="check8">
                            Owner is disable
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-12">
                    <div class="row">
                      <div class="col-4 mb-2">
                        <div class="d-flex align-items-end gap-1">
                          <p-checkbox
                            (click)="venderprofileCheckboxButton($event)"
                            name="Charity Friendly"
                            id="check9"
                            [binary]="true" />
                          <label class="form-check-label" for="check9">
                            Charity Friendly
                          </label>
                        </div>
                      </div>
                      <div class="col-4 mb-2">
                        <div class="d-flex align-items-end gap-1">
                          <p-checkbox
                            (click)="venderprofileCheckboxButton($event)"
                            name="Importer"
                            id="check10"
                            [binary]="true" />
                          <label class="form-check-label" for="check10">
                            Importer
                          </label>
                        </div>
                      </div>
                      <div class="col-4 mb-2">
                        <div class="d-flex align-items-end gap-1">
                          <p-checkbox
                            (click)="venderprofileCheckboxButton($event)"
                            name="Women Owner"
                            id="check11"
                            [binary]="true" />
                          <label class="form-check-label" for="check11">
                            Women Owner
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-12">
                    <div class="row">
                      <div class="col-4 mb-2">
                        <div class="d-flex align-items-end gap-1">
                          <p-checkbox
                            (click)="venderprofileCheckboxButton($event)"
                            name="BHUBZone"
                            id="check12"
                            [binary]="true" />
                          <label class="form-check-label" for="check12">
                            HUBZone
                          </label>
                        </div>
                      </div>
                      <div class="col-4 mb-2">
                        <div class="d-flex align-items-end gap-1">
                          <p-checkbox
                            (click)="venderprofileCheckboxButton($event)"
                            name="Made in USA"
                            id="check13"
                            [binary]="true" />
                          <label class="form-check-label" for="check13">
                            Made in USA
                          </label>
                        </div>
                      </div>
                      <div class="col-4 mb-2">
                        <div class="d-flex align-items-end gap-1">
                          <p-checkbox
                            (click)="venderprofileCheckboxButton($event)"
                            name="Minority Owned"
                            id="check14"
                            [binary]="true" />
                          <label class="form-check-label" for="check14">
                            Minority Owned
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row m-3 gray-bg-rounded">
            <div class="vendors-info pt-4">
              <h3>Contact Information</h3>
              <div class="row">
                <div class="col-lg-6">
                  <h3>Vendor Representative</h3>
                  <div class="row" formGroupName="vendorInformation">
                    <div class="col-4 mb-4">
                      <div class="form-group has-float-label">
                        <label class="form-label" for="name">Name</label>
                        <input
                          jniAutoCompleteBlocker
                          type="text"
                          pInputText
                          placeholder=""
                          id="name"
                          name="name"
                          pInputText
                          formControlName="vendorNameD365"
                          [ngClass]="{
                            'has-error': formErrors['vendorNameD365'],
                          }"
                          (blur)="logValidationErrors()" />

                        <span
                          class="error-msg"
                          *ngIf="formErrors['vendorNameD365']">
                          {{ formErrors["vendorNameD365"] }}
                        </span>
                      </div>
                    </div>
                    <div class="col-4 mb-4">
                      <div class="form-group has-float-label">
                        <label class="form-label" for="phoneNumber"
                          >Phone number</label
                        >
                        <input
                          jniAutoCompleteBlocker
                          type="text"
                          pInputText
                          id="phoneNumber"
                          name="phoneNumber"
                          placeholder=""
                          jni-phone-number-formatting
                          formControlName="vendorPhoneNumberD365"
                          [ngClass]="{
                            'has-error': formErrors['vendorPhoneNumberD365'],
                          }"
                          (blur)="logValidationErrors()" />

                        <span
                          class="error-msg"
                          *ngIf="formErrors['vendorPhoneNumberD365']">
                          {{ formErrors["vendorPhoneNumberD365"] }}
                        </span>
                      </div>
                    </div>
                    <div class="col-4 mb-4">
                      <div class="form-group has-float-label">
                        <label class="form-label" for="email"
                          >Email Address</label
                        >
                        <input
                          jniAutoCompleteBlocker
                          type="email"
                          pInputText
                          id="email"
                          name="email"
                          placeholder=""
                          formControlName="vendorEmailAddressD365"
                          [ngClass]="{
                            'has-error': formErrors['vendorEmailAddressD365'],
                          }"
                          (blur)="logValidationErrors()" />

                        <span
                          class="error-msg"
                          *ngIf="formErrors['vendorEmailAddressD365']">
                          {{ formErrors["vendorEmailAddressD365"] }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-6">
                  <h3>Inside Representative</h3>
                  <div class="row" formGroupName="insideInformation">
                    <div class="col-4 mb-4">
                      <div class="form-group has-float-label">
                        <label class="form-label" for="Name">Name</label>
                        <input
                          jniAutoCompleteBlocker
                          type="text"
                          pInputText
                          placeholder=""
                          id="Name"
                          name="name"
                          formControlName="insideNameD365"
                          [ngClass]="{
                            'has-error': formErrors['insideNameD365'],
                          }"
                          (blur)="logValidationErrors()" />

                        <span
                          class="error-msg"
                          *ngIf="formErrors['insideNameD365']">
                          {{ formErrors["insideNameD365"] }}
                        </span>
                      </div>
                    </div>
                    <div class="col-4 mb-4">
                      <div class="form-group has-float-label">
                        <label class="form-label" for="phoneNumber"
                          >Phone number</label
                        >
                        <input
                          jniAutoCompleteBlocker
                          type="text"
                          pInputText
                          placeholder=""
                          id="phoneNumber"
                          name="phoneNumber"
                          jni-phone-number-formatting
                          formControlName="insidePhoneNumberD365"
                          [ngClass]="{
                            'has-error': formErrors['insidePhoneNumberD365'],
                          }"
                          (blur)="logValidationErrors()" />

                        <span
                          class="error-msg"
                          *ngIf="formErrors['insidePhoneNumberD365']">
                          {{ formErrors["insidePhoneNumberD365"] }}
                        </span>
                      </div>
                    </div>
                    <div class="col-4 mb-4">
                      <div class="form-group has-float-label">
                        <label class="form-label" for="email"
                          >Email Address</label
                        >
                        <input
                          jniAutoCompleteBlocker
                          pInputText
                          type="email"
                          placeholder=""
                          id="email"
                          name="email"
                          formControlName="insideEmailAddressD365"
                          [ngClass]="{
                            'has-error': formErrors['insideEmailAddressD365'],
                          }"
                          (blur)="logValidationErrors()" />

                        <span
                          class="error-msg"
                          *ngIf="formErrors['insideEmailAddressD365']">
                          {{ formErrors["insideEmailAddressD365"] }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <h3 class="mb-3">Website</h3>
              <div class="row mb-1" formGroupName="websiteInformation">
                <div class="col-auto">
                  <div class="form-group switcher">
                    <label class="form-label d-block" for="applicable"
                      >Applicable</label
                    >

                    <div
                      class="form-check form-switch d-flex align-items-center form-switch-hgt mt-2">
                      <p-toggleswitch
                        type="checkbox"
                        id="flexSwitchCheckDefault2"
                        name="flexSwitchCheckDefaul2"
                        formControlName="websiteNameApplicable"
                        (change)="applicableClickEvent($event)" />
                    </div>
                  </div>
                </div>

                <div class="col">
                  <div class="form-group has-float-label">
                    <label class="form-label" for="Name"
                      >URL<span
                        *ngIf="websiteNameIsRequired"
                        class="madatory-field"
                        >*</span
                      ></label
                    >
                    <input
                      pInputText
                      jniAutoCompleteBlocker
                      type="text"
                      placeholder=""
                      id="Name"
                      name="Name"
                      formControlName="websiteNameD365"
                      [ngClass]="{
                        'has-error': formErrors['websiteNameD365'],
                      }"
                      (blur)="logValidationErrors()" />

                    <span
                      class="error-msg"
                      *ngIf="formErrors['websiteNameD365']">
                      {{ formErrors["websiteNameD365"] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="col" formGroupName="basicInformation">
                <div class="col">
                  <div class="form-group has-float-label">
                    <label class="form-label" for="privateBCVendorNotes"
                      >Private Bc Vendor Notes</label
                    >
                    <textarea
                      pInputText
                      rows="3"
                      jniAutoCompleteBlocker
                      placeholder=""
                      formControlName="privateBCVendorNotes"></textarea>
                  </div>
                </div>
              </div>
              <div class="col" formGroupName="basicInformation">
                <div class="col mb-4">
                  <div class="form-group has-float-label">
                    <label class="form-label" for="publicVendorNotes"
                      >Public Vendor Notes</label
                    >
                    <textarea
                      pInputText
                      rows="3"
                      jniAutoCompleteBlocker
                      placeholder=""
                      formControlName="publicVendorNotes"></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex m-3 justify-content-end gap-2">
            <p-button
              severity="secondary"
              label="Cancel"
              (click)="redirectToVendorListing()" />
            <p-button label="Save" (click)="CreateNewVendor()" />
          </div>
        </form>
      </div>
    </p-card>
  </div>
</div>
